import { useEffect, useState } from 'react';

/**
 * This hook makes SSR render with null and only render stuff when on the browser.
 * Useful to silence hydration warnings in a good way.
 */
export const useMounted = () => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted;
};
